import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { GridForm } from 'components/Ui/styled';
import {
  PaperProps,
  profilePreferenceSuccess,
  booleanOptions,
} from 'constants';
import {
  onSave,
  emptyFunction,
  getDialogHeading,
  renderSaveCancelButtons,
  refinePayload,
  useNotification,
} from 'utils/commonUtils';
import {
  getProfilePreferences,
  postProfilePreferences,
} from 'layouts/myProfile/service/myProfileApi';
import FormInputDropdown from 'components/Common/Forms/FormInputDropDown';

const MyPreferencesDialog = (props) => {
  const {
    myPreferencesDialog,
    setMyPreferencesDialog,
    profilePreferences,
    setProfilePreferences,
  } = props;

  const dispatch = useDispatch();

  const {
    setOpenNotification,
    setNotificationMessage,
    NotificationPopup,
    handleErrorResponse,
  } = useNotification();

  const [loadingButton, setLoadingButton] = useState(false);

  const defaultValue = {
    emailNotificationsEnabled: profilePreferences?.emailNotificationsEnabled,
    tutorEmailNotificationsEnabled:
      profilePreferences?.tutorEmailNotificationsEnabled,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });

  const { handleSubmit, control, reset } = useFunction;

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.emailNotificationsEnabled,
    defaultValue.tutorEmailNotificationsEnabled,
  ]);

  const handleClose = () => {
    setMyPreferencesDialog(false);
    reset(defaultValue);
  };

  const fetchProfilePreferences = async () => {
    try {
      const profilePreferences = await getProfilePreferences();
      setProfilePreferences(profilePreferences);
    } catch (error) {
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const onSubmit = async (data) => {
    const { emailNotificationsEnabled, tutorEmailNotificationsEnabled } = data;

    const payload = {
      emailNotificationsEnabled,
      tutorEmailNotificationsEnabled,
    };

    onSave(
      profilePreferenceSuccess,
      true,
      postProfilePreferences,
      emptyFunction,
      refinePayload(payload),
      '',
      fetchProfilePreferences,
      handleClose,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setLoadingButton,
      loadingButton
    );
  };

  return (
    <>
      <Dialog open={myPreferencesDialog} PaperProps={PaperProps}>
        {getDialogHeading('My Preferences', handleClose)}
        <GridForm container spacing={2}>
          <Grid item xs={12}>
            <FormInputDropdown
              name="emailNotificationsEnabled"
              control={control}
              options={booleanOptions}
              label="Enable Email Notifications"
            />
            <FormInputDropdown
              name="tutorEmailNotificationsEnabled"
              control={control}
              options={booleanOptions}
              label="Enable Tutor Email Notifications"
            />
            {renderSaveCancelButtons(
              handleClose,
              handleSubmit(onSubmit),
              loadingButton,
              false
            )}
          </Grid>
        </GridForm>
      </Dialog>
      <NotificationPopup />
    </>
  );
};

export default MyPreferencesDialog;
